;(function ($) { $.fn.datepicker.language['en'] = {
    days: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
    daysShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
    daysMin: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
    months: ['1월','2월','3월','4월','5월','6월', '7월','8월','9월','10월','11월','12월'],
    monthsShort: ['1월','2월','3월','4월','5월','6월', '7월','8월','9월','10월','11월','12월'],
    today: 'Today',
    clear: 'Clear',
    dateFormat: 'yyyy.mm.dd',
    timeFormat: 'hh:ii aa',
    firstDay: 0
}; })(jQuery);